export default {
  getRoleById: state => id => {
    return state.roles.find((r) => r._id === id).length ? state.roles.find((r) => r._id === id) : []
  }
}
